import React from 'react';
import LanguageSwitcher from '../../../components/common/LanguageSwitcher';
import Manual from "../../../components/common/Manual";
import {languages} from "../../../config/languages";
import {Box, Stack, Typography} from "@mui/material";
import {ActionsContainer, Line, LogosStack, NavBarContainer, NavBarRow, SidebarLogo} from "./NavBar.styled";
import mzLogo from '../../../assets/images/uck_mz_logo.png';
import kpoLogo from '../../../assets/images/uck_kpo_logo.png';
import {brand} from "../../../theme/brand";
import {useTranslation} from "react-i18next";
import {tokens} from "../../../theme";

interface NavBarProps {
    isSidebarOpen: boolean;
}

const NavBar = ({isSidebarOpen}: NavBarProps) => {
    const {t} = useTranslation();
    const languageList = languages.filter(lang => lang.forInterface);
    const showLogo = brand.hasNavBarLogo;

    return (
        <NavBarContainer>
            <NavBarRow>
                <SidebarLogo />

                <LogosStack $isSidebarOpen={isSidebarOpen}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        {showLogo && (
                            <Box component="img" src={kpoLogo} alt={t('brand.uck.kpoLogoAlt')} sx={{ height: '76px' }} />
                        )}
                        {showLogo && (
                            <Box component="img" src={mzLogo} alt={t('brand.uck.mzLogoAlt')} sx={{ height: '76px', maxWidth: 400 }} />
                        )}
                    </Stack>

                    {showLogo && (
                        <Typography color="text.secondary" variant="body2" sx={{ fontSize: tokens.fontSize.xs, p: '4px', textAlign: 'center' }}>
                            {t('brand.uck.financeInfo')}
                        </Typography>
                    )}
                </LogosStack>

                <ActionsContainer>
                    <LanguageSwitcher languageList={languageList}/>
                    <Manual/>
                </ActionsContainer>
            </NavBarRow>

            <Line />
        </NavBarContainer>
    );
};

export default NavBar;
